import React from 'react'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import { CalendarDays } from 'lucide-react'
import './DateRange.scss'

const toDate = (value) => {
    if (!value) return null
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime()) ? null : parsed
}

const toDateString = (value) => {
    if (!value) return null
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return null
    const year = parsed.getFullYear()
    const month = String(parsed.getMonth() + 1).padStart(2, '0')
    const day = String(parsed.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

const toDisplayDate = (value) => {
    if (!value) return ''
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return ''
    const day = String(parsed.getDate()).padStart(2, '0')
    const month = String(parsed.getMonth() + 1).padStart(2, '0')
    const year = parsed.getFullYear()
    return `${day}/${month}/${year}`
}

export default function DateRange({ startDate, endDate, onStartDateChange, onEndDateChange }) {
    const value = [toDate(startDate), toDate(endDate)]

    const handleChange = (nextRange) => {
        if (!Array.isArray(nextRange)) return
        const [nextStart, nextEnd] = nextRange
        onStartDateChange?.(toDateString(nextStart))
        onEndDateChange?.(toDateString(nextEnd))
    }

    return (
        <div className="app-date-range">
            <div className="app-date-range__inputs">
                <div className="app-date-range__field">
                    <label>From</label>
                    <div className="app-date-range__input-box">
                        <span>{toDisplayDate(startDate) || 'dd/mm/yyyy'}</span>
                        <CalendarDays size={16} />
                    </div>
                </div>

                <div className="app-date-range__field">
                    <label>To</label>
                    <div className="app-date-range__input-box">
                        <span>{toDisplayDate(endDate) || 'dd/mm/yyyy'}</span>
                        <CalendarDays size={16} />
                    </div>
                </div>
            </div>

            <DateRangePicker
                onChange={handleChange}
                value={value}
                isOpen
                format="dd/MM/y"
                clearIcon={null}
                calendarIcon={null}
                shouldCloseCalendar={() => false}
            />
        </div>
    )
}
